import React, { useMemo } from 'react';
import { ButtonBase, Stack, Typography } from '@mui/material';
import TutorialVideo from '@features/tutorial/shared/TutorialVideo';
import { APP_CONFIG } from '../../../../config/app.config';
import OnboardingSlidePager from '../../shared/OnboardingSlidePager';
import {
  WAREHOUSE_INFO_COPY,
  WarehouseInfoCategory,
} from './warehouseOnboarding.utils';

interface WarehouseOnboardingInfoStepProps {
  categories: WarehouseInfoCategory[];
  onFinish: () => void;
}

const WarehouseOnboardingInfoStep: React.FC<WarehouseOnboardingInfoStepProps> = ({
  categories,
  onFinish,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  const steps = useMemo(
    () =>
      categories.map((category) => {
        const copy = WAREHOUSE_INFO_COPY[category];
        return {
          key: category,
          content: ({ active }: { active: boolean }) => (
            <Stack direction="column" gap={2}>
              <Typography variant="body2">{copy.description}</Typography>
              {copy.videoSrc && (
                <TutorialVideo
                  src={copy.videoSrc}
                  ariaLabel={`${copy.tabLabel} warehouse tutorial`}
                  active={active}
                />
              )}
            </Stack>
          ),
        };
      }),
    [categories],
  );

  if (categories.length === 0) return null;

  return (
    <OnboardingSlidePager
      title="How we load your inventory"
      nextLabel="Next"
      doneLabel="Done"
      onComplete={onFinish}
      steps={steps}
    />
  );
};

export default WarehouseOnboardingInfoStep;
